import contentStudioInstance from '@/utils/axiosContentStudio';

interface CreateDubbingProjectParams {
  asset_ids: string[];
  project_name: string;
  languages: string[];
  enable_lip_sync: boolean;
  num_of_speakers?: number;
  analytics_params: CreateProjectAnalyticsParams;
}

interface CreateReformattingProjectParams {
  project_name: string;
  reformats: {
    asset_id: string;
    output_aspect_ratio: string;
  }[];
  analytics_params: CreateProjectAnalyticsParams;
}

interface CreateUpscaleProjectParams {
  project_name: string;
  upscales: {
    asset_id: string;
    output_resolution: string;
  }[];
  analytics_params: CreateProjectAnalyticsParams;
}

interface ApplyRephraseParams {
  projectId: string;
  base64Srt: string;
  enableLipSync?: boolean;
}

interface InitializeRephraseProjectParams {
  assetId: string;
  projectName: string;
  analytics_params: CreateProjectAnalyticsParams;
}

interface RenameProjectParams {
  projectId: string;
  projectName: string;
}

interface CreateProjectAnalyticsParams {
  interaction_id: string;
  session_id: string;
}

const projectUpdaters = {
  createDubbingProject: async (params: CreateDubbingProjectParams) => {
    const response = await contentStudioInstance.post(
      '/api/v1/projects/dubbing',
      params
    );
    return response.data;
  },

  createReformattingProject: async (
    params: CreateReformattingProjectParams
  ) => {
    const response = await contentStudioInstance.post(
      '/api/v1/projects/reformatting',
      params
    );
    return response.data;
  },

  createUpscaleProject: async (params: CreateUpscaleProjectParams) => {
    const response = await contentStudioInstance.post(
      '/api/v1/projects/upscale',
      params
    );
    return response.data;
  },

  initializeRephraseProject: async (
    params: InitializeRephraseProjectParams
  ) => {
    const response = await contentStudioInstance.post(
      '/api/v1/projects/rephrasing',
      {
        asset_id: params.assetId,
        project_name: params.projectName,
        analytics_params: params.analytics_params,
      }
    );
    return response.data;
  },
  renameProject: async (params: RenameProjectParams) => {
    const response = await contentStudioInstance.patch(
      `/api/v1/projects/${params.projectId}`,
      {
        project_name: params.projectName,
      }
    );
    return response.data;
  },
  applyRephrase: async (params: ApplyRephraseParams) => {
    const response = await contentStudioInstance.patch(
      `/api/v1/projects/rephrasing/${params.projectId}`,
      {
        transcription_base64: params.base64Srt,
        enable_lip_sync: params.enableLipSync,
      }
    );
    return response.data;
  },
};

export default projectUpdaters;
